import React, { useContext } from 'react'
import { useEffect, useState } from 'react'
import { axiosInstance } from '../../axios/interceptor' // Assuming you have an axios instance
import axios from 'axios'
import { PropertyCardImg } from '../../helper/imagepath'
import { appendImageURL } from '../../helper/function'
import { SpinnerContext } from '../../context/spinnerContext'
import heic2any from 'heic2any'
const FilePreview = ({
  propertyImages,
  file,
  fileUuid,
  imageURL,
  onRemove,
  module,
  setImages,
  onChange,
  onProgressChange,
  setImageKey,
  image,
  isAddMode
}) => {
  const [imagePreview, setImagePreview] = useState(image || '')
  const { changeLoader } = useContext(SpinnerContext)
  const getS3Post = async () => {
    try {
      const response = await axiosInstance.get(`/create-presigned-post-url-s3?module=${module}&name=${file.name.replace('.heic', '.jpeg')}`)
      return response.data.data
    } catch (error) {
      console.error('Failed to get presigned URL.')
      throw new Error('Failed to get presigned URL.')
    }
  }

  const uploadToS3 = async (presignedPostUrl, formData) => {
    try {
      const response = await axios.post(presignedPostUrl.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (data) => {
          const progress = Math.round((100 * data.loaded) / data.total)
          onProgressChange(fileUuid, progress) // Track progress
        }
      })

      if (response.status === 204) {
        const fileUrl = `${presignedPostUrl.fields.key}`
        setImageKey(`${presignedPostUrl.url}/${presignedPostUrl.fields.key}`)
        setImagePreview(fileUrl)
      }
    } catch (err) {
      console.error('Failed to upload to S3.')
      throw new Error('Failed to upload to S3.')
    }
    changeLoader(false)
  }

  const handleFileUpload = async (fileObj) => {
    changeLoader(true)
    try {
      const presignedPostUrl = await getS3Post()
      const formData = new FormData()
      if (fileObj.name.endsWith('.heic')) {
        const convertedFile = await heic2any({ blob: fileObj })
        formData.append('Content-Type', 'image/jpeg')
        Object.entries(presignedPostUrl.fields).forEach(([key, value]) => formData.append(key, value))
        formData.append('file', convertedFile)
      } else {
        formData.append('Content-Type', fileObj.type)
        Object.entries(presignedPostUrl.fields).forEach(([key, value]) => formData.append(key, value))
        formData.append('file', fileObj)
      }

      await uploadToS3(presignedPostUrl, formData)
    } catch (error) {
      console.error(error.message)
      changeLoader(false)
    }
  }

  useEffect(() => {
    if (file) {
      handleFileUpload(file)
    } else {
      setImagePreview(imageURL)
    }
  }, [file])

  // remove image from s3 bucket
  const removeUploadedFileFromS3 = async (fileKey, image) => {

    const data = {
      files: [fileKey]
    }
    const newFilesUrl = propertyImages?.filter((file) => file !== image)

    if (isAddMode) {
      return await axiosInstance
        .post(`/delete-image-s3`, data)
        .then((response) => {
          // remove image from local state
          response && onRemove(fileUuid)
          response && onChange(newFilesUrl)
          response && setImages(newFilesUrl)
          return response
        })
        .catch((err) => {
          console.log('Error while removing file from S3:', err)
        })
    } else {
      onRemove(fileUuid)
      onChange(newFilesUrl)
      setImages(newFilesUrl)
    }
  }

  // const imageKey = `Img${imagePreview?.split('/Img')[1]}`

  return (
    <>
      {imagePreview && (
        <div className="image-preview-container">
          <img src={imagePreview ? appendImageURL(imagePreview) : PropertyCardImg} alt="preview" className="image-preview" />
          <button className="delete-icon" type="button" onClick={() => removeUploadedFileFromS3(imagePreview, imagePreview)}>
            &times;
          </button>
        </div>
      )}
    </>
  )
}

export default FilePreview
